<template>
  <NuxtLink
    :to="$localePath(`/profile`)"
    class="link flex flex-col justify-center items-center p-2 relative"
  >
    <div class="flex justify-center">
      <ProfileLinkIcon :class="['inactive', { 'hidden': isActive }]" />
      <ProfileLinkActiveIcon :class="['active', { 'block': isActive, 'hidden': !isActive }]" />
    </div>
    <div
      class="text-xs font-medium pt-0.5 text-center md:text-xxs"
      :class="['text', { 'text-gray-600': !isActive, 'text-black': isActive }]"
    >
      Профиль
    </div>
  </NuxtLink>
</template>

<script>
import ProfileLinkActiveIcon from '~/assets/svg/header/profile-active.svg?component'
import ProfileLinkIcon from '~/assets/svg/header/profile.svg?component'
export default {
  components: {
    ProfileLinkIcon,
    ProfileLinkActiveIcon,
  },
  computed: {
    isActive () {
      return (this.$route.path.includes('/profile') && !this.$route.path.includes('/profile/messages') && !this.$route.path.includes('/profile/renter') && !this.$route.path.includes('/profile/owner'))
    },
  },
}
</script>
